<template>
    <div class="breadcrumb">
        <div class="breadcrumb-box">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="item in dataList" :to="{ path: item.path }">{{ item.name }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>
export default {
    props: ['dataList']
}
</script>

<style scoped lang="scss">
.breadcrumb {
    margin: 0 auto;
    background-color: #F8F8F8;

    .breadcrumb-box {
        padding: 15px 0;
        width: 1200px;
        margin: 0 auto;
    }
}
</style>
